import React from 'react';

const StatusIndicator = ({ status, deadline, approvalMaterialDeadline, approvalDeadline, outputDeadline, isOverdue, payroll_status }) => {
  const getStatusClass = () => {
    // Grå status for ingen lønkørsel eller lukket
    if (!status || status === "Lukket") return "status-closed";
    
    // Blå status for behandling og afventer afslutning
    if (payroll_status === 'processing' || 
        payroll_status === 'waiting_approval' || 
        payroll_status === 'approved') {
      return "status-processing";
    }
    
    // Grøn status for åben for input
    return "status-open";
  };

  const getStatusText = () => {
    if (!status) return "Ingen lønkørsel";
    if (status === "Lukket") return "Lønkørsel lukket";
    
    // Tilføj nye statustekster baseret på payroll_status
    if (payroll_status === 'processing' || payroll_status === 'waiting_approval') {
      return "Lønkørsel behandles";
    }
    if (payroll_status === 'approved') {
      return "Lønkørsel afventer afslutning";
    }
    
    return "Åben for input";
  };

  const getNextDeadline = () => {
    if (!status || status === "Lukket") return null;

    // Hvis payroll_status er null eller undefined, brug den gamle dato-baseret logik
    if (!payroll_status) {
      const now = new Date();
      const deadlines = [
        { date: new Date(deadline), type: "Input" },
        { date: new Date(approvalMaterialDeadline), type: "Godkendelsesmateriale" },
        { date: new Date(approvalDeadline), type: "Godkendelse" },
        { date: new Date(outputDeadline), type: "Outputfiler" }
      ];

      const nextDeadline = deadlines.find(d => d.date > now);
      if (!nextDeadline) return null;

      return {
        type: nextDeadline.type,
        date: nextDeadline.date.toLocaleDateString('da-DK', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        })
      };
    }

    // Ellers brug payroll_status til at bestemme næste deadline
    let deadlineType;
    let deadlineDate;

    switch (payroll_status) {
      case 'processing':
        deadlineType = "Godkendelsesmateriale";
        deadlineDate = new Date(approvalMaterialDeadline);
        break;
      case 'waiting_approval':
        deadlineType = "Godkendelse";
        deadlineDate = new Date(approvalDeadline);
        break;
      case 'approved':
        deadlineType = "Outputfiler";
        deadlineDate = new Date(outputDeadline);
        break;
      default:
        return null;
    }

    return {
      type: deadlineType,
      date: deadlineDate.toLocaleDateString('da-DK', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })
    };
  };

  const nextDeadline = getNextDeadline();

  return (
    <div className={`status-indicator ${getStatusClass()}`}>
      <span className="status-text">{getStatusText()}</span>
      {nextDeadline && status !== "Lukket" && (
        <span className="status-deadline">
          Næste deadline: {nextDeadline.type} d. {nextDeadline.date}
        </span>
      )}
    </div>
  );
};

export default StatusIndicator; 